import { createSlice } from '@reduxjs/toolkit';
import ASYNC_STATE from '../../constants/AsyncState';
import scrollToMessageId from './chatThunks/scrollToMessageId';

const asyncState = {
  scrollToMessageId: {
    status: ASYNC_STATE.IDLE,
    errorMessage: null,
  },
};

const initialState = {
  ...asyncState,
  scrollDownLock: false,
  shouldScrollDownChat: false,
  shouldScrollToMessageId: null,
  shouldScrollToMessageTarget: null,
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setScrollDownLock: (state, action) => {
      const { scrollDownLock } = action.payload;
      state.scrollDownLock = scrollDownLock;
    },
    scrollDownChat: (state) => {
      state.shouldScrollDownChat = true;
    },
    resetScrollDownChat: (state) => {
      state.shouldScrollDownChat = false;
    },
    resetScrollToMessageId: (state) => {
      state.shouldScrollToMessageId = null;
      state.shouldScrollToMessageTarget = null;
    },
    resetScrollToMessageError: (state) => {
      state.scrollToMessageId.errorMessage = null;
      state.scrollToMessageId.status = ASYNC_STATE.IDLE;
    },
  },
  extraReducers: {
    [scrollToMessageId.pending]: (state) => {
      state.scrollToMessageId.status = ASYNC_STATE.LOADING;
      state.scrollToMessageId.errorMessage = null;
    },
    [scrollToMessageId.fulfilled]: (state, action) => {
      state.scrollToMessageId.status = ASYNC_STATE.SUCCEEDED;
      const { channelId, messageId } = action.payload;
      state.scrollDownLock = false;
      state.shouldScrollToMessageId = messageId;
      state.shouldScrollToMessageTarget = { channelId, messageId };
    },
    [scrollToMessageId.rejected]: (state) => {
      state.scrollToMessageId.status = ASYNC_STATE.FAILED;
      state.scrollToMessageId.errorMessage = 'Nachricht konnte nicht geladen werden';
    },
  },
});

export const {
  setScrollDownLock,
  scrollDownChat,
  resetScrollDownChat,
  resetScrollToMessageId,
  resetScrollToMessageError,
} = chatSlice.actions;

export default chatSlice.reducer;
